export default __webpack_public_path__ + "static/media/croquis.2dec34e0.png";